import React from "react";
import BriefArticle from "../reusable/BriefArticle/BriefArticle";
import "./News.css";
import TEXT from "../../utils/text/news.json";
import { useCurrentLanguage } from "../../hooks/useCurrentLanguage";

export default function News() {
  const { language, languagePath } = useCurrentLanguage();

  return (
    <div className="news-box">
      <div className="news-title-container">
        <h1 className="news-title">{TEXT["title"][language]}</h1>
      </div>
      <div className="news-articles">
        {TEXT.content.map((item, key) => {
          return (
            <div key={key} className="news-article-container">
              <BriefArticle
                title={item.title[language]}
                description={item.description[language]}
                language={language}
                target={item.use_language_path ? "_self" : "_blank"}
                // 👇️ if the item has a language path, use it, otherwise use the default url
                href={
                  item.use_language
                    ? item.use_language_path
                      ? "#" + languagePath + item.url[language]
                      : item.url[language]
                    : item.url
                }
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
